var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapseTextInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4585 3.6756C34.425 3.6756 35.2085 4.4591 35.2085 5.4256V22.3423H52.1252C53.0917 22.3423 53.8752 23.1258 53.8752 24.0923C53.8752 25.0588 53.0917 25.8423 52.1252 25.8423H33.4585C32.492 25.8423 31.7085 25.0588 31.7085 24.0923V5.4256C31.7085 4.4591 32.492 3.6756 33.4585 3.6756Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7085 33.4256C3.7085 34.3921 4.492 35.1756 5.4585 35.1756H22.3752V52.0923C22.3752 53.0588 23.1587 53.8423 24.1252 53.8423C25.0917 53.8423 25.8752 53.0588 25.8752 52.0923V33.4256C25.8752 32.4591 25.0917 31.6756 24.1252 31.6756H5.4585C4.492 31.6756 3.7085 32.4591 3.7085 33.4256Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseTextInput);
export default __webpack_public_path__ + "static/media/collapse-text-input.c2a68116.svg";
export { ForwardRef as ReactComponent };